export const getRefreshToken = () => sessionStorage.getItem('refreshToken');

export const setRefreshToken = (token: string) => sessionStorage.setItem('refreshToken', token);

export const getToken = () => {
  const token = sessionStorage.getItem("token");

  if (token)
    return token;
  else
    return null;
};

export const setToken = (token: string) => sessionStorage.setItem('token', token);

export const clearTokens = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refreshToken');
};
